
import { Vue, Component, Prop, Emit } from "nuxt-property-decorator";
import HeaderMenuItem from "~/components/molecules/nav/Menu/HeaderMenuItem.vue";
import MyAccountIcon from "~/components/organisms/icon/MyAccountIcon.vue";
import menuData from "~/assets/data/menu.json";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import { getMkLogin, getMkLogout } from "~/operations";

const NON_PELLETS_SECTIONS = ["Heizöl", "Benzin"];

@Component({
  components: { RouterLink, MyAccountIcon, HeaderMenuItem },
})
export default class HeaderMenu extends Vue {
  @Prop() isLoggedIn: boolean;
  @Emit()
  onClose() {
    return false;
  }

  get menuTree() {
    return menuData.filter(
      (section) => !NON_PELLETS_SECTIONS.includes(section.name),
    );
  }

  get _getMkLogin() {
    return getMkLogin();
  }

  get _getMkLogout() {
    return getMkLogout();
  }
}
